export default {
    carbonCredit: {
        view: 'Bekijken',
        edit: 'Bewerken',
        back: 'Terug',
        preview: 'Voorvertoning',
        confirm: 'Bevestigen',
        cancel: 'Annuleren',
        dashboard: 'Dashboard',
        select: 'Selecteren',
        submit: 'Indienen',
        save: 'Opslaan',
        title: 'Koolstofkrediet',
        projects: 'Projecten',
        carbonProjectCredits: 'Koolstofprojectkredieten',
        carbonCreditProjects: 'Koolstofkredietprojecten',
        exportAs: 'Exporteren als',
        downloadAsCSV: 'Downloaden als CSV',
        downloadAsExcel: 'Downloaden als Excel',
        downloadAsPDF: 'Downloaden als PDF',
        registerNewProject: 'Nieuw Project Registreren',
        creditInfo: '*Dit is het geschatte aantal kredieten. Het werkelijke aantal kredieten kan anders zijn na verificatie.',
        search: 'Zoeken',
        projectTitle: 'Projecttitel',
        projectType: 'Projecttype',
        country: 'Land',
        totalCreditsGenerated: 'Totaal gegenereerde kredieten',
        status: 'Status',
        descriptionPlaceholder: "Geef een beschrijving van het project inclusief doelen",
        filePreviewNotAvailable: 'Bestandsvoorvertoning is niet beschikbaar voor dit bestandstype',
        active: 'Actief',
        inactive: 'Inactief',
        pending: 'In afwachting',
        proposed: 'Voorgesteld',
        planned: 'Gepland',
        inProgress: 'In uitvoering',
        operational: 'Operationeel',
        deactivated: 'Gedeactiveerd',
        avoidedDeforestation: 'Vermeden ontbossing',
        agroForestry: 'Agroforestry',
        forestry: 'Bosbouw',
        regenerativeAgriculture: 'Regeneratieve landbouw',
        agroforestry: 'Agroforestry',
        regenerative_agriculture: 'Regeneratieve landbouw',
        projectDeletedSuccessfully: 'Project succesvol gedeactiveerd',
        projectUpdatedSuccessfully: 'Project succesvol bijgewerkt',
        projectRegisteredSuccessfully: 'Project succesvol geregistreerd',
        deactivateProjectError: 'Fout bij het deactiveren van project',
        deactivate: 'Deactiveren',
        deactivateProject: 'Project deactiveren',
        deactivateConfirmation: 'Weet u zeker dat u dit project wilt deactiveren?',
        registerProject: 'Nieuw Project Registreren',
        editProject: 'Project Bewerken',

        register: { 
            title: 'Project Registreren',
            editTitle: 'Project Bewerken',
            projectTitle: 'Projecttitel',
            projectType: 'Projecttype',
            description: 'Beschrijving',
            selectCountry: "Land selecteren",
            selectOrganization: 'Organisaties selecteren',
            status: 'Status',
            creditType: 'Krediettype',
            creditStart: 'Krediet start',
            creditEnd: 'Krediet einde',
            standardMethodology: 'Standaard/Methodologie',
            validationDocumentation: 'Validatiedocumentatie',
            vintage: 'Vintage',
            currency: 'Valuta',
            projectInfo: 'Projectinformatie',
            organizationDetails: 'Organisatiedetails',
            attachmentTitle: 'Bijlage(n)',
            attachmentInfo: 'U kunt extra documenten, afbeeldingen, video en audiobestanden toevoegen die relevant zijn voor het project',
            documentation: 'Documentatie',
            sdgsTitle: 'Duurzame Ontwikkelingsdoelen (SDG\'s)',
            sdgsInfo: 'Selecteer alleen de doelen die relevant zijn voor dit specifieke project. Organisaties hebben toegang om alleen de doelen te bekijken die aan dit project zijn gekoppeld.',
            dataCollectionTitle: 'Datacollectiecyclus',
            dataCollectionInfo: 'Om deel te nemen aan het Koolstofkredietprogramma moeten boeren historische boerderijgegevens verstrekken tijdens inschrijving en doorgaan met het indienen van periodieke data-updates zolang het programma actief blijft. Dit zorgt voor nauwkeurige tracking van koolstofprestaties in de loop van de tijd.',
            vintageYear: 'Vintage jaar',
            estimatedCredit: 'Geschatte kredieten',
            pricePerCredit: 'Prijs per krediet',
            moduleName: 'Modulenaam',
            futureData: 'Toekomstige terugkerende datacollectie',
            score: 'Score',
            approval: 'Goedkeuring',

            projectAgreement: 'Projectovereenkomst',
            headerImage: 'Headerafbeelding',
            headerImageInfo: '(Headerafbeelding grootte 1920 x 420 pixels. Standaardafbeelding wordt vervangen door nieuwe afbeelding die u uploadt)',
            headerImagePlaceholder: "Standaard headerafbeelding",
            responsibleDimitraOffice: 'Verantwoordelijk Dimitra-kantoor',
            selectDimitraOffice: 'Dimitra-kantoor selecteren',
            makeASelection: 'Maak een selectie',
            addNewDimitraOffice: 'Nieuw Dimitra-kantoor toevoegen',
            editDimitraOffice: 'Dimitra-kantoor bewerken',
            officeName: 'Kantoornaam',
            contactPerson: 'Contactpersoon naam',
            phoneNumber: 'Telefoonnummer',
            email: 'E-mail',
            address: 'Adres',
            officeNameRequired: 'Kantoornaam is vereist',
            contactPersonRequired: 'Contactpersoon naam is vereist',
            addressRequired: 'Adres is vereist',
            phoneNumberRequired: 'Telefoonnummer is vereist',
            phoneNumberInvalid: 'Telefoonnummer is ongeldig',
            phoneNumberLength: 'Telefoonnummer moet minimaal 10 cijfers lang zijn',
            selectVintage: 'Vintage selecteren',
            officeAddedSuccessfully: 'Dimitra-kantoor succesvol toegevoegd',
            errorAddingOffice: 'Fout bij het toevoegen van Dimitra-kantoor',
            searchOrganizations: 'Organisaties zoeken',
            searchOrganizationsPlaceholder: 'Zoeken op organisatienaam...',
            noOrganizationsFound: 'Geen organisaties gevonden',
            loadingOrganizations: 'Organisaties laden...',
            selectedOrganizations: 'Geselecteerde organisaties',
            errorNegative: 'kan niet negatief zijn.',
            errorRequiredField: '{field} is vereist.',
            errorOrganizationRequired: 'Ten minste één organisatie moet worden geselecteerd.',
            errorVintageRequired: 'Ten minste één vintage-invoer is vereist.',
            errorVintageFieldsRequired: 'Alle vintage-velden (jaar, kredieten, prijs) zijn vereist.',
            allOrganizations: 'Alle organisaties',
            removal: 'Verwijdering',
            avoided: 'Vermeden',
            mandatory: 'Verplicht',
            scoreValidationError: 'Ongeldige score voor module "{module}". Score moet een geheel getal 0 of groter zijn.',
            approvalValidationError: 'Ongeldige goedkeuring voor module "{module}". Goedkeuring moet een geheel getal tussen 0 en 100 zijn.',
            saveError: 'Project opslaan mislukt',
            fileUploadFailed: 'Bestandsupload mislukt',
            unsupportedFileFormat: 'Niet-ondersteund bestandsformaat',
            errorUploadingFile: 'Fout bij het uploaden van bestand',
            scoreError: {
                invalid: 'Score moet een geldig nummer zijn',
                range: 'Score moet 0 of groter zijn',
                wholeNumber: 'Score moet een geheel getal zijn'
            },
            approvalError: {
                invalid: 'Goedkeuring moet een geldig nummer zijn',
                range: 'Goedkeuring moet tussen 0 en 100 liggen',
                wholeNumber: 'Goedkeuring moet een geheel getal zijn'
            },
            selectStatus: 'Status selecteren',
            selectCreditType: 'Krediettype selecteren',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standaard',
            browse: 'Bladeren',
            currencyPlaceholder: 'USD',
            selectFile: 'Bestand selecteren',
            dragDropFiles: 'Bestanden hier slepen en neerzetten',
            hideDetails: 'Details verbergen',
            viewDetails: 'Details bekijken',
            website: 'Website',
            month: 'Maand(en)',
            year: 'Jaar',
        },

        error: 'Fout',
        success: 'Succes',
        remove: 'Verwijderen',

        projectInfo: {
            title: 'Projectinformatie',
            organizationDetail: 'Organisatiedetail',
            subOrganizations: 'Sub-organisaties',
            search: 'Zoeken',
            organizations: 'Organisaties',
            users: 'Gebruikers',
            registrationDate: 'Registratiedatum',
            close: 'Sluiten',
            country: 'Land',
            organizationsAddress: 'Organisatieadres',
            blockchainAddress: 'Blockchain-adres',
            creditType: 'Krediettype',
            projectType: 'Projecttype',
            officeName: 'Kantoornaam',
            contactPersonName: 'Contactpersoon naam',
            contactNumber: 'Contactnummer',
            email: 'E-mail',
            address: 'Adres',
            website: 'Website',
            companyName: 'Bedrijfsnaam',
            companyAddress: 'Bedrijfsadres',
            web: 'Website',
            vintageYear: 'Vintage jaar',
            estimatedCredits: 'Geschatte kredieten',
            pricePerCredit: 'Prijs per krediet',
            module: 'Module',
            recurring: 'Terugkerend',
            score: 'Score',
            approval: 'Goedkeuring',
            responsibleDimitraOffice: 'Verantwoordelijk Dimitra-kantoor',
            status: 'Status',
            standardMethodology: 'Standaard/Methodologie',
            validationDocumentation: 'Validatiedocumentatie',
            creditStart: 'Krediet start',
            creditEnd: 'Krediet einde',
            attachmentTitle: 'Bijlage(n)',
            sdgsTitle: 'Duurzame Ontwikkelingsdoelen (SDG\'s)',
            dataCollectionTitle: 'Datacollectiecyclus',
            dataCollectionInfo: 'Om deel te nemen aan het Koolstofkredietprogramma moeten boeren historische boerderijgegevens verstrekken tijdens inschrijving en doorgaan met het indienen van periodieke data-updates zolang het programma actief blijft. Dit zorgt voor nauwkeurige tracking van koolstofprestaties in de loop van de tijd.',
            vintage: 'Vintage',
            moduleName: 'Modulenaam',
            futureData: 'Toekomstige terugkerende datacollectie',
            estimatedCredit: 'Geschatte kredieten',
        },

        user: {
            title: 'Koolstofkredietgebruiker(s)',
            selectOrganization: 'Organisatie selecteren',
            selectProject: 'Project selecteren',
            allUsers: 'Alle gebruikers',
            activeUsers: 'Actieve gebruikers',
            deactivatedUsers: 'Gedeactiveerde gebruikers',
            pendingUsers: 'Wachtende gebruikers',
            search: 'Zoeken',
            farmerName: 'Boer naam',
            farmName: 'Boerderij naam',
            organizations: 'Organisaties',
            country: 'Land',
            projectTitle: 'Projecttitel',
            registerProject: 'Nieuw Project Registreren',
            actions: 'Acties',
            noData: 'Geen gebruikers gevonden.',
            view: 'Bekijken',
            viewLandPermit: 'Landtitel / Vergunning bekijken',
            edit: 'Bewerken',
            deactivate: 'Deactiveren',
            deactivateUser: 'Gebruiker deactiveren',
            deactivateConfirmation: 'Weet u zeker dat u deze gebruiker wilt deactiveren?',
            activate: 'Activeren',
            activateUser: 'Gebruiker activeren',
            activateConfirmation: 'Weet u zeker dat u deze gebruiker wilt activeren?',
            deactivatedSuccessfully: 'Gebruiker succesvol gedeactiveerd',
            activatedSuccessfully: 'Gebruiker succesvol geactiveerd',
            deactivationFailed: 'Fout bij het deactiveren van gebruiker',
            exportAsPdf: 'Exporteren als PDF',
            projectDetails: 'Projectdetails',
            dateJoined: 'Datum toegetreden',
            cropGrowingPractice: 'Gewasteeltpraktijk',
            farm: 'Boerderij',
            rejectAll: 'ALLE AFWIJZEN',
            acceptAll: 'ALLE ACCEPTEREN',
            confirmRejectAll: 'U staat op het punt om verzoeken voor alle boerderijen om lid te worden van het koolstofkredietproject af te wijzen. Deze actie zal elke boerderij uitsluiten die door de boer in dit verzoek is ingediend. Weet u zeker dat u wilt doorgaan?',
            confirmAcceptAll: 'U staat op het punt om verzoeken voor alle boerderijen om lid te worden van het koolstofkredietproject te accepteren. Deze actie zal elke boerderij opnemen die door de boer in dit verzoek is ingediend. Weet u zeker dat u wilt doorgaan?',
            dateOfRegistration: 'Registratiedatum',
            farmRegistrationId: 'Boerderij registratie-ID',
            dimitraFarmId: 'Dimitra boerderij-ID',
            notTheFarmer: "Ik ben niet de boer",
            farmerFirstName: 'Boer voornaam',
            farmerMiddleName: 'Boer tweede naam',
            farmerLastName: 'Boer achternaam',
            farmerRegistrationId: 'Boer registratie-ID',
            dimitraFarmerId: 'Dimitra boer-ID',
            farmGeofence: 'Boerderij geofence',
            viewGeofence: 'Geofence bekijken',
            totalFarmSize: 'Totale boerderijgrootte',
            mainGoals: 'Wat zijn uw hoofddoelen',
            ownershipType: 'Eigendomstype',
            certifications: 'Certificering(en)',
            productionType: 'Productietype',
            landTitle: 'Landtitel',
            farmLocationAddress: 'Boerderij locatieadres',
            farmCoordinate: 'Boerderij coördinaat',
            farmerAgreement: 'Boer overeenkomst',
            viewSignedAgreement: 'Bekijk ondertekende overeenkomst ingediend met de aanvraag.',
            viewAgreement: 'OVEREENKOMST BEKIJKEN',
            acceptanceStatus: 'Acceptatiestatus',
            currentStatus: 'Huidige status',
            reject: 'AFWIJZEN',
            accept: 'ACCEPTEREN',
            farmActivitySubmissions: 'Boerderij activiteit inzendingen',
            farmActivitySubmissionsDesc: 'Ingediende records van landbouwpraktijken en updates vereist voor koolstofkredietverificatie.',
            viewFarmData: 'BOERDERIJGEGEVENS BEKIJKEN',
            farmData: 'Boerderijgegevens',
            farmDataDesc: 'Maak uw rapporten door productiegegevens van verschillende bronnen te integreren. Selecteer één of meerdere bronnen om een complete lijst van productieplaatsen voor uw rapporten samen te stellen.',
            crops: 'Gewassen',
            sowing: 'Zaaien',
            seedling: 'Zaailing',
            fertilizer: 'Meststof',
            fertilizerError: 'Incomplete inzending: Meststofinformatie voor 4 maanden ontbreekt in de boer invoer.',
            harvesting: 'Oogsten',
            livestock: 'Vee',
            equipment: 'Uitrusting',
            projectRequests: 'Projectverzoeken',
            userNameAndId: 'Gebruikersnaam en ID',
            email: 'E-mail',
            userRole: 'Gebruikersrol',
            status: 'Status',
            userRegistrationDate: 'Registratiedatum gebruiker',
            pending: 'In afwachting',
            deactivated: 'Gedeactiveerd',
            active: 'Actief',
            selectProjectTypeFirst: 'Selecteer eerst het projecttype',
            noFarmsToReject: 'Geen boerderijen om af te wijzen',
            allFarmsRejected: 'Alle boerderijen succesvol afgewezen',
            rejectAllError: 'Alle boerderijen afwijzen mislukt',
            noFarmsToAccept: 'Geen boerderijen om te accepteren',
            allFarmsAccepted: 'Alle boerderijen succesvol geaccepteerd',
            acceptAllError: 'Alle boerderijen accepteren mislukt',
            farmNotFound: 'Boerderij niet gevonden of niet gekoppeld aan project',
            farmAlreadyRejected: 'Boerderij is al afgewezen',
            farmRejected: 'Boerderij succesvol afgewezen',
            rejectFarmError: 'Boerderij afwijzen mislukt',
            farmAlreadyAccepted: 'Boerderij is al geaccepteerd',
            farmAccepted: 'Boerderij succesvol geaccepteerd',
            acceptFarmError: 'Boerderij accepteren mislukt',
        },
    }
} 